import { render } from "./IframeVideoPlayer.vue?vue&type=template&id=408c441a&scoped=true&ts=true"
import script from "./IframeVideoPlayer.vue?vue&type=script&lang=ts"
export * from "./IframeVideoPlayer.vue?vue&type=script&lang=ts"

import "./IframeVideoPlayer.vue?vue&type=style&index=0&id=408c441a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408c441a"]])

export default __exports__